import Tippy from '@tippyjs/react';

import { cn, formatLargeNumber } from 'lib/helpers/utility';

import Badge from 'components/shared/Badge/Badge';
import Icon from 'components/shared/Icon/Icon';
import Typography from 'components/shared/Typography/Typography';

const ControlItem = ({ item, isActive, disabled, onClick, count, loading, className }) => (
  <Tippy className="tippy-dark" disabled={!item?.tooltip} content={item?.tooltip}>
    <div
      key={item.value}
      data-targetid={`control-${item.value}`}
      data-qa={item.dataQa}
      className={cn(
        'flex h-7 w-fit items-center justify-center gap-1 rounded px-4 py-0',
        {
          'bg-white shadow-md': isActive,
          'bg-transparent': !isActive,
          'cursor-pointer': !disabled,
          'cursor-not-allowed': disabled
        },
        className
      )}
      onClick={() => !disabled && onClick(item)}
      role="button"
      tabIndex={disabled ? -1 : 0}
      aria-pressed={isActive}
      aria-disabled={disabled}>
      {item.icon && (
        <Icon
          icon={item.icon}
          className="cursor-pointer"
          color={isActive ? 'primary' : 'neutral'}
        />
      )}
      {item.label && (
        <Typography
          color={isActive ? 'neutral-800' : 'neutral-600'}
          disabled={disabled}
          weight="medium"
          variant="span"
          size="small"
          className="cursor-pointer whitespace-nowrap">
          {item.label}
        </Typography>
      )}
      {(item.count || (isActive && count)) && !loading && (
        <Badge color="neutral" size="small" text={formatLargeNumber(item.count || count)} />
      )}
    </div>
  </Tippy>
);

export default ControlItem;
